export const FilteredViewHotkeys = {
  filters: 'F',
  search: '/',
} as const

export const PhonePageHotkeys = {
  dial: 'C',
  settings: 'S',
} as const

export const CallsPageHotkeys = {
  next: 'ArrowDown',
  previous: 'ArrowUp',
} as const

export const CapabilitiesPageHotkeys = {
  createCapability: 'C',
  search: FilteredViewHotkeys.search,
} as const

export const CasesPageHotkeys = {
  filters: FilteredViewHotkeys.filters,
  search: FilteredViewHotkeys.search,
  showDisplayOptions: 'V',
} as const

export const EncountersPageHotkeys = {
  clearFilters: 'C',
  clearSelection: 'Escape',
  filters: FilteredViewHotkeys.filters,
  search: FilteredViewHotkeys.search,
} as const

export const AgentRunChatHotkeys = {
  quoteSelection: 'Mod+L',
} as const

export const PatientsPageHotkeys = {
  search: FilteredViewHotkeys.search,
} as const

export const ProvidersPageHotkeys = {
  search: FilteredViewHotkeys.search,
} as const

export const DropboxPageHotkeys = {
  search: FilteredViewHotkeys.search,
} as const

export const FilesTreePageHotkeys = {
  search: '/',
} as const

export const EditableDocumentsPageHotkeys = {
  search: FilteredViewHotkeys.search,
} as const

export const AnalysisPageHotkeys = {
  exitEdit: 'Escape',
  redo: { key: 'Z', mod: true, shift: true },
  undo: 'Mod+Z',
} as const

export const PatientDetailsPageHotkeys = {
  copyPatientId: 'Mod+.',
  copyPatientUrl: { key: ',', mod: true, shift: true },
} as const

export const AgentChatHotkeys = {
  copyConversationId: 'Mod+Alt+.',
  focusInput: 'C',
  openSavedPrompts: 'Control+B',
  selectSavedPrompt: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
  toggleMode: 'Control+Shift+F',
} as const

export const DataOncallHotkeys = {
  askAgent: { key: '.', mod: true, shift: true },
  cancelAsk: 'Escape',
  closePanel: 'Escape',
  toggleLeaderboard: ['L', 'L', 'L'],
} as const

export const EncounterTimelineHotkeys = {
  showDisplayOptions: 'V',
} as const

export const TagHotkeys = {
  addTag: 'T',
} as const

export const EncounterDetailsPageHotkeys = {
  addToProject: 'P',
  addToRequest: 'R',
  copyAccountId: 'Mod+Alt+A',
  copyEncounterId: 'Mod+.',
  copyEncounterUrl: { key: ',', mod: true, shift: true },
  copyPatientId: 'Mod+Alt+P',
  detailsTab: 'D',
  eligibilityTab: 'E',
  flagForJoyfulFollowup: 'F',
  openNewAgentChat: 'N',
  overviewTab: 'O',
  startBillerAgent: { key: 'B', mod: true, shift: true },
} as const

export const FloatingListNavigationPanelHotkeys = {
  nextItem: 'ArrowRight',
  previousItem: 'ArrowLeft',
  togglePanel: 'Q',
} as const

export const KpiEmailsRouteHotkeys = {
  settings: 'S',
} as const

export const InternalInvoicesRouteHotkeys = {
  contract: 'C',
} as const

export const ProjectsPageHotkeys = {
  createProject: 'C',
  filters: FilteredViewHotkeys.filters,
  saveReorder: 'Mod+Enter',
  showDisplayOptions: 'V',
  undoReorder: 'Mod+Z',
} as const

export const AgentProposalsPageHotkeys = {
  approve: 'Mod+Enter',
  filters: FilteredViewHotkeys.filters,
  nextProposal: 'ArrowRight',
  previousProposal: 'ArrowLeft',
  reject: 'R',
  showDisplayOptions: 'V',
} as const

export const KnowledgePageHotkeys = {
  filters: FilteredViewHotkeys.filters,
  search: FilteredViewHotkeys.search,
} as const

export const RequestsPageHotkeys = {
  filters: FilteredViewHotkeys.filters,
  search: FilteredViewHotkeys.search,
} as const

export const RequestDetailsPageHotkeys = {
  copyRequestId: 'Mod+.',
  copyRequestUrl: { key: ',', mod: true, shift: true },
} as const

export const PracticeRequestSuggestedAnswersHotkeys = {
  select: ['1', '2', '3', '4'],
  submit: 'Enter',
} as const

export const ProjectDetailsPageHotkeys = {
  copyProjectId: 'Mod+.',
  copyProjectUrl: { key: ',', mod: true, shift: true },
} as const

export const LogicDiagramDetailsPageHotkeys = {
  copyDiagramId: 'Mod+.',
  copyDiagramUrl: { key: ',', mod: true, shift: true },
  find: 'Mod+F',
  fitView: 'Shift+1',
  redo: { key: 'Z', mod: true, shift: true },
  setAccountScope: 'A',
  setDiagramType: 'T',
  undo: 'Mod+Z',
  zoomIn: 'Mod+=',
  zoomOut: 'Mod+-',
} as const

export const LogicDiagramsPageHotkeys = {
  filters: FilteredViewHotkeys.filters,
  search: FilteredViewHotkeys.search,
  showDisplayOptions: 'V',
} as const

export const AnnouncementsPageHotkeys = {
  createAnnouncement: 'C',
} as const

export const MembersRouteHotkeys = {
  inviteUser: 'I',
} as const

export const BillerAssignmentsHotkeys = {
  discardChanges: 'Mod+Z',
  filters: FilteredViewHotkeys.filters,
  saveChanges: 'Mod+Enter',
} as const

export const WorkBlocksPageHotkeys = {
  nextDay: 'ArrowRight',
  previousDay: 'ArrowLeft',
} as const

export const AuditWorkblocksPageHotkeys = {
  nextItem: 'ArrowDown',
  previousItem: 'ArrowUp',
} as const

export const UsersPageHotkeys = {
  search: FilteredViewHotkeys.search,
} as const

export const FeatureFlagsPageHotkeys = {
  filters: FilteredViewHotkeys.filters,
  search: FilteredViewHotkeys.search,
} as const

export const ImageLightboxHotkeys = {
  nextImage: 'ArrowRight',
  previousImage: 'ArrowLeft',
  zoomIn: { key: '=', shift: true },
  zoomOut: '-',
} as const

export const GlobalHotkeys = {
  accountSelection: 'A',
  askAiDirect: 'Mod+Alt+K',
  devTools: 'Alt+.',
  displaySettings: 'Alt+,',
  globalCommand: 'Mod+K',
  happyHolidays: 'H',
  leaveFeedback: 'Alt+F',
  phone: {
    dialPad: 'Mod+D',
    hangup: 'Mod+H',
    mute: 'M',
  },
} as const
